import React, { useEffect, useState, useCallback } from 'react';
import { FunctionComponentReturnType } from 'src/types/sharedReact';
import { GetIsUserAuthenticatedResponse } from 'src/types/apiResponse';
import RouteBuilder from 'src/utils/routing/RouteBuilder';
import { useRouteBuilder } from 'src/utils/routing/RouteBuilderContext';
import Tile from 'src/containers/Tile/Tile';
import axios from 'axios';
import 'src/pages/LoginPage/LoginPage.css';
import LoadingIndicator from 'src/components/LoadingIndicator/LoadingIndicator';
import { GrvTypographyClass } from 'src/types/gravity';
import { Button } from '@c1/gravity-react';

function LoginPage( {
    bannerUtilityRef
    }): FunctionComponentReturnType {
    const [isWaitingForRedirect, setWaitingForRedirect] = useState<boolean>(false);
    const routeBuilder: RouteBuilder = useRouteBuilder();
    const ssoLoginPath: string = routeBuilder.api.login();
    const getIsUserAuthenticatedRoute: string = routeBuilder.api.getIsUserAuthenticated();
    const bannerId = "loginPageBanner"

    // Non-prod copp hosts (dev-copp.*, qa-copp.*, localhost) point at the developerit
    // DevEx environment; prod (copp.capitalone.com) points at developer.
    const isNonProdHost = (): boolean => {
        const hostname = window.location.hostname;
        return hostname.includes('dev') || hostname.includes('qa') || hostname.includes('localhost');
    };
    const devExSubdomain = isNonProdHost() ? 'developerit' : 'developer';
    const DEVEX_LOGIN_URL = `https://${devExSubdomain}.capitalone.com/auth/sign-in?returnTo=%2Fpartnerships%2Fanalytics`;

    const handleSubmit = useCallback((overrideUri: string): void => {
        if (!isWaitingForRedirect) {
            setWaitingForRedirect(true);
            console.log("Redirecting to: '" + overrideUri + "'");
            window.location.assign(overrideUri);
        }
    }, [isWaitingForRedirect]);


    // Run on login page load
    useEffect(() => {
        // Check for error query
        let errorMessageToDisplay = (new URLSearchParams(window?.location?.search))?.get("error")
        console.log(errorMessageToDisplay)
        console.log(bannerUtilityRef)
        if(errorMessageToDisplay) {
            errorMessageToDisplay = errorMessageToDisplay.replace(/[^0-9a-zA-Z ]/g, '');
            let banner = {
                id: bannerId,
                bannerMessage: errorMessageToDisplay,
                bannerType: "error",
                isActive: "true"
            };
            bannerUtilityRef?.current?.addBanner(banner)
        }

        // clear marketing page local
        Object.keys(localStorage)
        .filter(x => x.startsWith('copp_mobile_marketing_'))
        .forEach(x => localStorage.removeItem(x));

        // Clear all cookies on load
        let cookies = document.cookie.split(';')
        cookies.forEach(cookie => {
            const splitIndex = cookie.indexOf('=');
            const name = splitIndex > -1 ? cookie.substring(0, splitIndex) : cookie;
            console.log("Removing Cookie: " + name);
            document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
        });

        // Check if user is already logged in
        console.log("Auth: Checking status")
        axios.get<GetIsUserAuthenticatedResponse>(getIsUserAuthenticatedRoute, { withCredentials: true })
        .then((isUserAuthenticatedRes) => {
            if ((isUserAuthenticatedRes?.data?.status && isUserAuthenticatedRes.data.status == 'OK')) {
                setWaitingForRedirect(true)
                console.log("Auth: User is authenticated, redirecting to home page")
                bannerUtilityRef?.current?.removeBannerById(bannerId)
                window.location.assign('/')

            }
            console.log("Auth: User is not authenticated")
        })
    }, [getIsUserAuthenticatedRoute])

    return (
        <div>
           <Tile className="login-tile">
               <p className={GrvTypographyClass.headingLarge}>Please Select Your Login Type</p>
               <span className={GrvTypographyClass.bodyNormal}>We will validate your credentials and re-direct you for Partner Portal access.</span>
               <br />
               {
                   (!isWaitingForRedirect) ?
                       <div className="login-type-buttons">
                           <Button
                               type="progress"
                               id="copp-button-capital-one-users"
                               onClick={() => handleSubmit(ssoLoginPath)}
                           >
                               Capital One Users
                           </Button>
                           <Button
                               type="progress"
                               id="copp-button-partner-users"
                               onClick={() => handleSubmit(DEVEX_LOGIN_URL)}
                           >
                               Partner Users
                           </Button>
                       </div>
                   :
                       <LoadingIndicator />
               }
              
           </Tile>
        </div>
    );
}

export default LoginPage;
